import Http from "../data/demo";
import { API, AUTH_URL, APPID, APP_SECRET, AUTH_INFO } from "../constants/conf";

import axios from 'axios';
import md5 from 'js-md5';

import { CHANNEL } from '../constants/conf';

import notice from './notice';
import confirm from './confirm';


// const AUTH_URL = 'http://oauth.neway.com/show';
// const APPID = '2qOvUdnLbzTBT6OE0KrG9nTiSI';


const SESSION_KEY = "__USER__";
var Auth = {
  isAuthenticated: false, // TODO
  user: {},
  // authenticate(data, cb) {
  //   setTimeout (function () {
  //     if (data.name === 'admin' && data.password === 'root@1234') {
  //       sessionStorage.setItem ('__USER__', data.name)
  //       Auth.user = {
  //         name: data.name
  //       }
  //       Auth.isAuthenticated = true
  //       cb ({ error: 0 })
  //     } else {
  //       cb ({ error: 1, msg: '用户名或密码错误' })
  //     }
  //   }, 500)

  // },
  signout(cb) {
    this.isAuthenticated = false;
    this.user = {}
    localStorage.removeItem ('__USER__')
    // setTimeout (cb, 100);
  },

  auth(user) {
    if (user) {
      this.isAuthenticated = true;
      // this.user = user;
      // if (Role.isUnset()) {
      //   Modal.info({
      //     title: "权限未分配",
      //     content: "请等待或联系管理员分配权限！"
      //   });
      // }
      localStorage.setItem(SESSION_KEY, JSON.stringify(user));
    }
  },

  get authUri() {
    return window.location.origin + "/#/auth";
  },
  goToAuth(redirectUrl) {
    let href = AUTH_URL + "?response_type=code&state=wayz&client_id=" + APPID;

    if (!_.isNil(redirectUrl)) {
      console.log(redirectUrl);
      console.log(encodeURIComponent(redirectUrl));

      href += "&redirect_uri=" + encodeURIComponent(redirectUrl);
    }

    window.location.href = href;
  },

};

function errorHandler(error) {
  let errorTitle = '网络出现错误: network error';
  let errorContent;
  if (error && error.response) {
    errorTitle = `错误码: ${error.response.data.code}`;
    errorContent = error.response.data.message;
  }
  confirm({
    type: 'error', 
    title: errorTitle, 
    content: errorContent, 
    onOk: () => {
      envFuns.logout(Auth.authUri);
    },
  });
}

const envFuns = {
  isLogin() {
    return Auth.isAuthenticated
  },
  login(cb) {
    const access_token = localStorage.getItem('ACCESS_TOKEN');
    const sessionid = localStorage.getItem('SESSION_ID');
    Http.login({access_token, sessionid})
      .then(
        res => {
          if (res.status === 200) {
            localStorage.setItem('ACCESS_TOKEN', res.data.access_token);
            localStorage.setItem('SESSION_ID', res.data.sessionid);
            localStorage.setItem('__USER__', res.data.user_name);
            const userName = res.data.user_name;
            Auth.user = {
              name: userName
            }
            Auth.isAuthenticated = true
            cb && cb();
          }
        },
        error => {
          errorHandler(error);;
        }
      )   
  },
  
  logout(redirectUri) {
    Auth.isAuthenticated = false;
    localStorage.removeItem('__USER__');
    localStorage.removeItem('ACCESS_TOKEN');
    localStorage.removeItem('SESSION_ID');
    Auth.goToAuth(redirectUri);
  },

  get currentLocation() {
    return window.location.href;
  },

  /**
   * 跳转到统一auth页面
   */
  goAuth(redirectUri) {
    Auth.goToAuth(redirectUri);
  },




  /**
   * 用code去换取token
   */
  authWithCode: function(code, redirectUrl, cb) {
    if (!code) {
      console.error("No valid code to auth with!");
    } else {
      Http.login(
        {
          code,
          redirect_uri: redirectUrl,
        },
        true,
      )
      .then(
        res => {
          console.log(res);
          if (res.status === 200) {
            const userName = res.data.user_name;
            localStorage.setItem ('__USER__', userName);
            localStorage.setItem ('ACCESS_TOKEN', res.data.access_token);
            localStorage.setItem ('SESSION_ID', res.data.sessionid);
            Auth.user = {
              name: userName
            }
            Auth.isAuthenticated = true;
            cb && cb();
          }
        },
        error => {
          errorHandler(error);;
        }
      )
    }
  },



  getUser() {
    return Auth.user
  },
  getUserInfo(cb) {
    let user = sessionStorage.getItem ('__USER__')
    if (user) {
      Auth.isAuthenticated = true
      Auth.user = { name: user }
    }
    cb (Auth.user)
  }
}

export default envFuns;



// WEBPACK FOOTER //
// ./src/util/env.js